/**
 * The action vocabulary (UX_ARCHITECTURE.md, rule G). One name per
 * interaction, everywhere an operation is shown. A control that does one of
 * these things uses this word, not a variant ("Show log", "Open output",
 * "View full output", "Open log at error").
 */
export const actionLabel = {
  /** Goes to the error itself: the failed step, with its message in view. */
  viewError: 'View error',
  /** Opens more of one item, in place or in a panel. Disclosures toggle with hideDetails. */
  viewDetails: 'View details',
  hideDetails: 'Hide details',
  /** Opens the complete, searchable log of the operation. */
  fullLogs: 'Full logs',
  /** Runs the same operation again. */
  retry: 'Retry',
  /** Brings data back from a backup. Never used for "undo a dismissal". */
  restore: 'Restore',
  /** Goes to where the cause is looked for: an incident, a check, a monitor. */
  investigate: 'Investigate',
} as const;

export type ActionLabel = (typeof actionLabel)[keyof typeof actionLabel];
